import { z } from "zod";

/**
 * Workspace-grant schemas — a drive/file Workspace reaching a Role.
 */

/**
 * A drive/file Workspace's access to a Role — the same M:N exception as
 * RoleCollectionGrant (a Workspace can be shared across multiple Roles).
 * Unlike PermissionSetGrantSchema, there is no `surface` — a Workspace grant is
 * not scoped to one app surface.
 */
export const RoleWorkspaceGrantSchema = z.object({
  id: z.string(),
  roleId: z.string(),
  organizationId: z.string(),
  workspaceId: z.string(),
  createdAt: z.string()
});

export type RoleWorkspaceGrant = z.infer<typeof RoleWorkspaceGrantSchema>;

export const RoleWorkspaceGrantsListResponseSchema = z.object({
  grants: z.array(RoleWorkspaceGrantSchema)
});

export const RoleWorkspaceGrantCreateBodySchema = z.object({
  workspaceId: z.string().min(1)
});

export const RoleWorkspaceGrantPathVarsSchema = z.object({
  id: z.string().uuid(),
  grantId: z.string().uuid()
});

/** Deleting a grant is idempotent — `removed` says whether a row actually went. */
export const RoleWorkspaceGrantDeleteResponseSchema = z.object({
  removed: z.boolean()
});
